import { render, staticRenderFns } from "./SalaInterview.vue?vue&type=template&id=327982e5&scoped=true"
import script from "./SalaInterview.vue?vue&type=script&lang=js"
export * from "./SalaInterview.vue?vue&type=script&lang=js"
import style0 from "./SalaInterview.vue?vue&type=style&index=0&id=327982e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327982e5",
  null
  
)

export default component.exports